import UiToast from '@/components/ui/Toast'

export default {
  install(Vue) {
    const Toast = Vue.extend(UiToast)
    const instance = new Toast()
    instance.$mount(document.createElement('div'))
    document.body.appendChild(instance.$el)
    const methods = {
      show(options) {
        if(typeof options === 'string') {
          instance.text = options
        } else if(typeof options === 'object') {
          Object.keys(options).forEach((key) => {
            instance[key] = options[key]
          })
        }
        instance.show = {}
      },

      hide() {
        instance.show = null
      }
    }
    if(!Vue.$ui) {
      Vue.$ui = {
        toast: methods
      }
      Vue.prototype.$ui = {
        toast: methods
      }
    } else {
      Vue.$ui.toast = methods
    }
  }

}



// WEBPACK FOOTER //
// ./src/plugins/toast.js